import './sass/main.scss';
import './js/teamLightbox';
import './js/galleryRender';
import './js/switch-theme/switch-theme';
import { addBackToTop } from 'vanilla-back-to-top';

addBackToTop();
